import script from "./AppointmentCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentCalendar.vue?vue&type=script&setup=true&lang=js"

import "./AppointmentCalendar.vue?vue&type=style&index=0&id=d6b192d6&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6b192d6"]])

export default __exports__